<template>
  <div class="slider-section">
    <div class="text-body-3 text-secondary-1">
      {{ label }}
    </div>

    <q-slider
      class="slider-cmp"
      :value="value"
      :min="0"
      :max="10"
      :step="1"
      dense
      snap
      label-always
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    label: String
  }
}
</script>

<style lang="scss" scoped>
.slider-section {
  display: contents;

  .slider-cmp {
    color: var(--r-primary-1) !important;

    ::v-deep {
      .q-slider__track-container--h {
        margin-top: -2px !important;
        height: 3px;
        background: var(--r-white-4);
      }
    }
  }
}
</style>
